"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processPaymentResponse = void 0;
const processPaymentRequestUpdate_1 = require("./processPaymentRequestUpdate");
const processPaymentResponse = async (supabase, request) => {
    await (0, processPaymentRequestUpdate_1.processPaymentRequestUpdate)(supabase, request);
};
exports.processPaymentResponse = processPaymentResponse;
